import { required, emailValid, minLength } from "@/services/ValidatorService";
export const registerForm = {
  name: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "Name",
      placeholder: "Enter name",
      "persistent-hint": true,
      rules: [required]
    }
  },
  phone: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "phone",
      placeholder: "Enter phone",
      "persistent-hint": true,
      rules: [required]
    }
  },
  whatsapp: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "whatsapp",
      placeholder: "Enter whatsapp",
      "persistent-hint": true,
      rules: []
    }
  },
  jobPosition: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "job",
      placeholder: "Enter job position",
      "persistent-hint": true,
      rules: [required]
    }
  },
  branch: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "branch",
      placeholder: "Select branch",
      "persistent-hint": true,
      rules: [required]
    }
  },
  email: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      id: "email",
      placeholder: "Enter email",
      "persistent-hint": true,
      rules: [required, emailValid]
    }
  },
  password: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      counter: true,
      id: "password",
      placeholder: "Enter password",
      "persistent-hint": true,
      rules: [required, minLength(8)]
    }
  },
  verifyPassword: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      counter: true,
      id: "passwordVerified",
      placeholder: "Confirm password",
      "persistent-hint": true,
      rules: [required, minLength(8)]
    }
  },
  passwordEdit: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      counter: true,
      id: "password",
      placeholder: "Enter password",
      "persistent-hint": true
    }
  },
  verifyPasswordEdit: {
    value: "",
    props: {
      outlined: true,
      dense: true,
      counter: true,
      id: "passwordVerified",
      placeholder: "Confirm password",
      "persistent-hint": true
    }
  }
};
